import { Button, Heading, Icon, Modal, Spinner, Text } from "@ttc3k/trekker";
import { Tree } from "iconoir-react";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import { Center, Flex, Grid } from "styled-system/jsx";

type TagManagerFlyoutProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description: string;
  footer: React.ReactNode;
  error?: boolean;
  loading?: boolean;
} & PropsWithChildren;

export const TagManagerFlyout = ({
  isOpen,
  onClose,
  title,
  description,
  footer,
  error,
  loading,
  children,
}: TagManagerFlyoutProps) => {
  const { t } = useTranslation("adminland", {
    keyPrefix: "PAGE.TAG_MANAGER.FLYOUTS",
  });

  return (
    <Modal
      open={isOpen}
      placement={"rightPane"}
      onOpenChange={onClose}
      hideCloseTrigger={true}
      portal
    >
      <Grid
        gridTemplateRows={"auto 88px"}
        h={"full"}
        gap={"0px"}
        gridGap={"0px"}
        gridRowGap={"0px"}
        overflow="hidden"
      >
        <Flex
          flexDirection={"column"}
          py={"600"}
          px={"500"}
          overflowY={"auto"}
          gap="250"
        >
          <Button mode="light" onClick={onClose} type="button" w="fit-content">
            {t("BACK")}
          </Button>
          {error ? (
            <Center
              maxW={"600px"}
              gap={"200"}
              flexDir={"column"}
              h={"full"}
              px={"500"}
            >
              <Icon
                Element={Tree}
                w={"40px"}
                h={"40px"}
                color={"icon.success.mid"}
              />
              <Heading size={"h5"}>{t("ERROR.TITLE")}</Heading>
              <Text textAlign={"center"} color={"text.mid"}>
                {t("ERROR.DESCRIPTION")}
              </Text>
            </Center>
          ) : (
            <>
              <Heading size={"h4"} color={"text.dark"}>
                {title}
              </Heading>
              <Text color={"text.mid"}>{description}</Text>
              {loading ? (
                <Center h={"full"} mt={"400"}>
                  <Spinner width={"70px"} height={"70px"} />
                </Center>
              ) : (
                <>
                  {/* Body */}
                  {children}
                </>
              )}
            </>
          )}
        </Flex>
        {/* Footer */}
        <Flex
          px={"500"}
          py={"300"}
          borderTopWidth={"1px"}
          borderColor={"border.light"}
          borderStyle={"solid"}
          boxShadow={"0px 0px 8px 0px rgba(0, 0, 0, 0.10)"}
          justifyContent={"space-between"}
          gap={"150"}
        >
          {footer}
        </Flex>
      </Grid>
    </Modal>
  );
};
